export class DocumentData {
  documentName: string;
  documentType: string;
  documentData: any;
}
